import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { useSelector } from 'react-redux';
import { selectCardsById } from '../Cards/selectors';
import MatLayout from '../Board/MatLayout';
import { isMatTurned } from '../Board/layout';
import { MiniFrame } from './styled';
import { pictureSpot } from '../Board/pictureSpot';

/**
 * A small picture of a game for the games list, laid out exactly like the game's mat (MatLayout): prizes, the active
 * Pokémon, the bench, the deck and the discard pile on both sides, face down where you can't see them yet. The
 * server sends what's there (`board`).
 */
const MiniBoard = ({ game, userId }) => {
  const cardsById = useSelector(selectCardsById);
  const board = game.get('board') || List();
  const mine = board.find(side => side.get('user_id') === userId);
  const theirs = board.find(side => side.get('user_id') !== userId);

  return (
    <MiniFrame aria-hidden="true">
      <MatLayout
        turned={isMatTurned(game, userId)}
        opponentSpot={pictureSpot(theirs, cardsById)}
        playerSpot={pictureSpot(mine, cardsById)}
      />
    </MiniFrame>
  );
};

MiniBoard.propTypes = {
  game: PropTypes.instanceOf(Map).isRequired,
  userId: PropTypes.number,
};

export default MiniBoard;
